import base64 from '../global/base64.js';
import md5 from 'js-md5'
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';
import global from '../global/global.js';

import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading

const startLoading = () => { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0)'
  })
}
const endLoading = () => { //使用Element loading-close 方法
  loading.close()
}

const fSmApiReq = async (sReqUrl, sApiName, sMethodName, sReqJsonStr, sApiUserPhone, sApiUserId, sApiReqFrom,
  sApiRandomStr, sApiReqOrgAk, sApiReqOrgSk, checkSignType = 'MD5') => {


  let sReqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let sReqJsonBase64 = Base64.encode(sReqJsonStr);

  // 组装签名

  let sApiReqSign = sApiReqOrgSk + sReqJsonBase64 + sReqTime + sApiReqOrgSk;
  sApiReqSign = md5(sApiReqSign);
  sApiReqSign = sApiReqSign.toLowerCase();

  let js = {};
  // API名称
  js['API_NAME'] = sApiName;
  // 请求方法名
  js['METHOD_NAME'] = sMethodName;
  // 请求json BASE64字符串
  js['REQ_JSON_STR'] = sReqJsonBase64;
  // API用户手机号
  js['API_USER_PHONE'] = sApiUserPhone;
  // API用户ID
  js['API_USER_ID'] = sApiUserId || '1001';
  // 请求来源
  js['API_REQ_FROM'] = sApiReqFrom;
  // 请求TOKEN
  js['API_REQ_TOKEN'] = global.fGetPlatform().partnerInfo.token; //
  // 请求随机字符串
  js['API_RANDOM_STR'] = sApiRandomStr;
  // 请求机构AK
  js['API_REQ_ORG_AK'] = sApiReqOrgAk;
  // 请求签名
  js['API_REQ_SIGN'] = sApiReqSign;
  // 请求时间
  js['API_REQ_TIME'] = sReqTime;



  js['ORG_AK'] = sApiReqOrgAk || '1234';
  js['REQ_JSON'] = sReqJsonBase64;
  js['MCH_ID'] = sApiUserPhone;
  js['USER_ID'] = sApiUserId || '1001';
  js['REQ_IP'] = '127.0.0.1';
  js['REQ_FROM'] = sApiReqFrom;
  js['REQ_VER'] = 'smPlatform';
  js['REQ_TIME'] = sReqTime;
  js['REQ_TOKEN'] =  global.fGetPlatform().partnerInfo.token; //

  console.log(js)
  if (sApiName == 'smSellAdminApi' || sApiName == 'smSellWgoApi' || sApiName == 'smSellQueryApi') {}
  startLoading()
  let res = await axios.post(sReqUrl, js);
  console.log(res)
  // if ( res.data.msg == 'tokenFail') {
  //   window.location.replace('http://soft.sanmipos.com/smSellAdmin/index.html')
  //   return {
  //     // data: {
  //     result: 'fail',
  //     msg: '请重新登录'
  //     // }
  //   }
  // }
  endLoading()

  return res.data;
};


//smSell主服务器接口
const fPostToSmSellMainSrvApi = (sMethodName, reqJson = {}, post = '') => {
  let sReqUrl = 'https://www.91byk.com/smSellMain/api/smSellApi/';
  if (post) {
    sReqUrl = 'http://' + post + ':5837/api/smSellApi/';
  }
  let sApiUserPhone = global.fGetPlatform().partnerInfo.phone || '18957102098'
  let sApiUserId = '1001'
  // }
  return fSmApiReq(sReqUrl, 'smSellMainSrvApi', sMethodName, JSON.stringify(reqJson),
    sApiUserPhone, sApiUserId, 'WEB');
  // store.state.smWgoSh.phoneNo
};

//smSell后台接口
const fPostToSmSellAdminApi = (sMethodName, reqJson = {}) => {
  // store.state.smWgoSh.shLoadUrl
  let sReqUrl = store.state.smSellAdmin.shLoadUrl + '/api/smSellApi/';
  return fSmApiReq(sReqUrl, 'smSellAdminApi', sMethodName, JSON.stringify(reqJson),
    store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB');
  // store.state.smWgoSh.phoneNo

};
//wgo接口
const fPostToSmSellWgoApi = (sMethodName, reqJson = {}) => {
  let sReqUrl = store.state.smSellAdmin.shLoadUrl + '/api/smSellApi/';

  return fSmApiReq(sReqUrl, 'smSellWgoApi', sMethodName, JSON.stringify(reqJson),
    store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB');

};

//smSell查询接口
const fPostToSmSellQueryApi = (sMethodName, reqJson = {}, post = '') => {
  let sReqUrl = store.state.smSellAdmin.shLoadUrl + '/api/smSellApi/';
  // console.log(sReqUrl)
  return fSmApiReq(sReqUrl, 'smSellQueryApi', sMethodName, JSON.stringify(reqJson),
    store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB');

};
//支付接口
const fPostToSmPayAggApi = async (sMethodName, reqJson = {}, url, app_id, app_secret) => {
  let sReqUrl = url
  console.log(JSON.stringify(reqJson))
  return fSmApiReq(sReqUrl, 'smPayAggApi', sMethodName, JSON.stringify(reqJson),
    app_id, store.state.smSellAdmin.userId, 'WEB', '', app_id, app_secret);

};


export default {
  fPostToSmSellAdminApi, //smSell后台接口
  fPostToSmSellQueryApi, //smSell查询接口
  fPostToSmSellWgoApi, //wgo接口
  fPostToSmSellMainSrvApi, //smSell主服务器接口
  fPostToSmPayAggApi
}



// WEBPACK FOOTER //
// ./src/common/requset/smSellApi.js